import React from 'react';
import {Redirect, Route} from 'react-router-dom';
import {checkCookie, getCookie} from 'ubs-framework/v2/common/function';
import {useSelector} from 'react-redux'
import { SLUG_TYPE_PRODUCT, SIGNUP_STEPS } from '../common/constant';

const STEP_ROUTES = {
    'register': 0,
    'verify-otp': 1,
    'company-details': 2,
    'company-other-info': 3,
    'building': 4,
};

const getSignUpRedirectPath = (step) => {
    const slugType = localStorage.getItem('slugType') || 'track';
    const orgId = localStorage.getItem('signUpOrgId');
    const stepRoute = SIGNUP_STEPS[step];
    if (!stepRoute) return null;
    if (step <= 2) return `/${slugType}/${stepRoute}`;
    if (step <= 4 && orgId) return `/${orgId}/${slugType}/${stepRoute}`;
    return null;
};

const PublicRoute = ({component: Component, restricted, ...rest}) => {
    const _AFTRP = useSelector(e => e.common.aftrp)
    const slugType = localStorage.getItem('slugType')
    const route = window.location.pathname?.split('/')?.[1]

    return (
        // restricted = false meaning public route
        // restricted = true meaning restricted route
        <Route {...rest} render={props => {
            if(props?.location?.search?.includes("redirect_uri") && props?.location?.search?.includes("client_id") && props?.location?.search?.includes("code_challenge")) {
                return (<Redirect to={`/authorize?${props?.location?.search}`}/>)
            } else if (checkCookie('ubs_token') && ["/:orgId/preboarding/register"]?.includes(props?.match?.path) && props?.match?.params?.orgId) {
                /** , Redirect To RECRUIT | Email URL is change from backend after 23-12-2024, every user will Redirect to Register Page, not Login */
                const preBoardingId = getCookie('preBoardingId')
                window.location.href = `${process.env.REACT_APP_RECRUIT_MODULE_URL}/${props?.match?.params?.orgId}/boarding-document/${preBoardingId}`
            } else if (checkCookie('ubs_token') && ["/:orgId/login"]?.includes(props?.match?.path) && props?.match?.params?.orgId) {
                /** Do not Remove this For Working old Email URL - redirection, Code adding date 23-12-2024, You can Remove after - 6 month of date */
                window.location.href = `${process.env.REACT_APP_RECRUIT_MODULE_URL}/${props?.match?.params?.orgId}/boarding-document/:preBoardingId`
            } else if (checkCookie('ubs_token') && !props?.match?.params?.orgId && ['/multi-factor-authenticate', '/setup-multi-factor', '/recovery-code', '/forget-with-recovery']?.includes(props?.match?.path)) {
                return (<Component {...props} />)
            } else if (checkCookie('ubs_token') && !["/:orgId/register"]?.includes(props?.match?.path)) {
                /** OnboardingUser will not Redirected to workspace */
                return (<Redirect to={_AFTRP ? '/change-password' : '/workspace'}/>)
            } else if (checkCookie('ubs_token') && ["/:orgId/register"]?.includes(props?.match?.path) && props?.match?.params?.orgId) {
                /** Redirect TO HRMS Module for onboarding*/
                window.location.href = `${process.env.REACT_APP_HRMS_MODULE_URL}/${props?.match?.params?.orgId}/employee-onboarding/employee-preview/:onboardingId`
            } else if ([`/${route}/company-details`, `/:orgId/track/company-other-info`, `/:orgId/track/building`]?.includes(props?.match?.path) && (!checkCookie('signup_token'))) {
                /** Redirect TO HRMS Module for onboarding*/
                return (<Redirect to={`/login`}/>)
            } else {
                /** Step validation for track registration flow */
                const pathSegments = props?.match?.path?.split('/');
                const lastSegment = pathSegments?.[pathSegments.length - 1];
                const routeStep = STEP_ROUTES[lastSegment];

                if (routeStep !== undefined && checkCookie('signup_token')) {
                    const storedStep = parseInt(localStorage.getItem('signUpStep'));
                    if (!isNaN(storedStep) && storedStep !== routeStep) {
                        const redirectPath = getSignUpRedirectPath(storedStep);
                        if (redirectPath) return (<Redirect to={redirectPath}/>)
                    }
                }

                return (<Component {...props} />)
            }
        }}/>
    );
};

export default PublicRoute;